import React from 'react'
import Navbar from '../components/Navbar/Navbar'
import Footer from '../components/Footer/Footer'
import TermsConditions from '../components/Privacyandterms/TermsConditions'





const Termspage = () => {
  return (
    <div>
        <Navbar/>
        <TermsConditions/>

        <Footer/>
    </div>
  )
}

export default Termspage